export default __webpack_public_path__ + "static/FancyMediaContentNine-96401fcca55ed93fa85a6ec61ef6d29c.webp";